import * as z from 'zod';
import { isoDateSchema } from '../../opaque.mjs';
import { currencySchema } from '../../utils.mjs';

const wipDocumentSectionSchema = z.enum(["WIP", "CJ"]);
const wipDerivationPathSchema = z.enum(["atomic", "printed_tec", "printed_egp", "sparse"]);
const wipRowKindSchema = z.enum(["detail", "aggregate"]);
const wipConfidenceTierSchema = z.enum(["VERIFIED", "PARTIAL", "UNCERTAIN"]);
const WipConfidenceTier = wipConfidenceTierSchema.enum;
const wipSourceScopeSchema = z.enum(["standalone", "package"]);
const wipJobStatusSchema = z.enum(["open", "closed"]);
const wipPageNumbersSchema = z.array(z.number().int().positive());
const wipSignalSeveritySchema = z.enum(["fail", "review"]);
const wipSignalReasonCodeSchema = z.enum([
    "EGP_MISMATCH",
    "TEC_MISMATCH",
    "REVENUE_MISMATCH",
    "SUBPERIOD_MISMATCH",
    "BILLED_NE_CONTRACT",
    "PERCENT_COMPLETE_MISMATCH",
    "PERCENT_COMPLETE_BOUNDS",
    "PERCENT_COMPLETE_NOT_100",
    "INSUFFICIENT_DATA",
    "BACK_DERIVED",
    "SECTION_SUM_MISMATCH",
    "UNITS_MISMATCH",
    "PROJECT_IDENTIFIER_TRUNCATED",
    "ROWS_DROPPED",
    "COUNT_MISMATCH",
    "NO_ROWS_EXTRACTED",
]);
const wipSignalAnchorSchema = z.discriminatedUnion("level", [
    z.object({
        level: z.literal("row"),
        sourceRefID: z.string(),
        projectNumber: z.string(),
        projectName: z.string(),
    }),
    z.object({
        level: z.literal("table"),
        tableID: z.string(),
        section: wipDocumentSectionSchema.optional(),
        field: z.string().optional(),
    }),
    z.object({ level: z.literal("document") }),
]);
const wipSignalDetailSchema = z.object({
    field: z.string().optional(),
    tableID: z.string().optional(),
    derived: z.number().optional(),
    printed: z.number().optional(),
    delta: z.number().optional(),
    count: z.number().optional(),
    expected: z.number().optional(),
});
var WipConfidenceSignal;
(function (WipConfidenceSignal) {
    WipConfidenceSignal.schema = z.object({
        code: wipSignalReasonCodeSchema,
        severity: wipSignalSeveritySchema,
        anchor: wipSignalAnchorSchema,
        detail: wipSignalDetailSchema.optional(),
    });
})(WipConfidenceSignal || (WipConfidenceSignal = {}));
const wipAtomicFieldsSchema = z.object({
    contractTotalAmount: currencySchema.nullable(),
    totalCostToDate: currencySchema.nullable(),
    totalBilledToDate: currencySchema.nullable(),
    totalEstimatedCost: currencySchema.nullable(),
});
var WipScheduleProject;
(function (WipScheduleProject) {
    WipScheduleProject.schema = z.object({
        projectNumber: z.string(),
        projectName: z.string(),
        documentSection: wipDocumentSectionSchema,
        entity: z.string().optional(),
        reportingYear: z.number().nullable(),
        sourceRefID: z.string(),
        ...wipAtomicFieldsSchema.shape,
        estimatedCostToComplete: currencySchema.nullable(),
        estimatedGrossProfit: currencySchema.nullable(),
        percentComplete: z.number().nullable(),
        cumulativeRevenueEarned: currencySchema.nullable(),
        grossProfitToBeEarned: currencySchema.nullable(),
        derivationPath: wipDerivationPathSchema,
        confidence: wipConfidenceTierSchema,
        rowKind: wipRowKindSchema.default("detail"),
    });
})(WipScheduleProject || (WipScheduleProject = {}));
var WipScheduleData;
(function (WipScheduleData) {
    WipScheduleData.schema = z.object({
        statementDate: isoDateSchema.nullable(),
        pageNumbers: wipPageNumbersSchema.default([]),
        projects: z.array(WipScheduleProject.schema),
        signals: z.array(WipConfidenceSignal.schema),
    });
})(WipScheduleData || (WipScheduleData = {}));

export { WipConfidenceSignal, WipConfidenceTier, WipScheduleData, WipScheduleProject, wipAtomicFieldsSchema, wipConfidenceTierSchema, wipDerivationPathSchema, wipDocumentSectionSchema, wipJobStatusSchema, wipPageNumbersSchema, wipRowKindSchema, wipSignalAnchorSchema, wipSignalDetailSchema, wipSignalReasonCodeSchema, wipSignalSeveritySchema, wipSourceScopeSchema };
